// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36KMI","placeholdersHeader":"styles_placeholdersHeader__2zEED","editorStyle":"styles_editorStyle__nWvYo","placeholdersBox":"styles_placeholdersBox__12ZD-"};